import React, { useState, useEffect } from "react";
import { useNavigate  } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Home from "../Home";
import Breadcrumb from "../../components/Breadcrumb";
import { Modal, Spinner } from "react-bootstrap";
import { customerRequestDetails, withdrawOrgRequest } from "./actions";

/*** 
@purpose : Functional component
@Parameter : {props}
**/
function OrganizationCustomerDetails() {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const [lang] = useTranslation("language");
  const [data, setData] = useState({});
  const [resubmit, setResubmit] = useState("");
  const [edit, setEdit] = useState("");
  const [withdraw, setWithdraw] = useState("");
  const [showWithdraw, setShowWithdraw] = useState(false);
  const [withdrawLoading, setWithdrawLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [requestNotFound, setRequestNotFound] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [specialityList, setSpecialityList] = useState([]);
  const [specialityResponseList, setSpecialityResponseList] = useState([]);
  const routes = [
    {
      name: `${lang("Menu.home")}`,
      path: "/",
    },
    {
      name: `${lang("Menu.customerRequestStatus")}`,
      path: "/customerRequestStatus",
    },
  ];
  const withdrawRoutes = [
    {
      name: `${lang("Menu.home")}`,
      path: "/",
    },
    {
      name: `${lang("Menu.organizationCustomer")}`,
      path: "/organizationCustomer",
    },
    {
      name: `${lang("organizationDetails.orgCustomerChangeRequest")}`,
      path: "",
    },
  ];

  useEffect(() => {
    async function fetchRequestDetails() {
      try {
        let id;
        let list = [];
        let responseList = [];
        let url = window.location.href;
        id = unescape(url).split("?reqId=")[1];
        let body = {
          id: id,
        };
        
        const response = await customerRequestDetails(body);
        if (response.success === true) {
          setData(response.data);
          setResubmit(response.canResubmit);
          setEdit(response.canEdit);
          setWithdraw(response.canWithdraw);
          
          response.data.specialities.value.map((sp) => {
            sp.specialityName && list.push(sp.specialityName);
          });
          
          if (
            response.data.specialities &&
            response.data.specialities.response_from_ultmarc.length > 0
          ) {
            response.data.specialities.response_from_ultmarc.map((sp) => {
              sp.specialityName && responseList.push(sp.specialityName);
            });
            setSpecialityResponseList(responseList);
          }
          setSpecialityList(list);
        } else if (
          response.success === false &&
          response.data.message === "given Request id not found"
        ) {
          setRequestNotFound(true);
        }
      } catch (error) {
        console.error("Error fetching request details:", error);
      } finally {
        setIsLoading(false);
      }
    }
    
    fetchRequestDetails();
  }, []);

  /*** 
  @purpose : Close modal
  @Parameter : {}
  **/
  const handleClose = () => setShow(false);

  /*** 
  @purpose : Close error modal
  @Parameter : {}
  **/
  const handleCloseError = () => setShowError(false);

  /*** 
  @purpose : Show modal
  @Parameter : {}
  **/
  const modalShow = () => setShow(true);

  /*** 
  @purpose : Withdraw request
  @Parameter : {}
  **/
  const withdrawRequest = async () => {
    try {
      setWithdrawLoading(true);
      setShow(false);
      let body = {
        id: data.submission_id.value,
      };
      
      const response = await withdrawOrgRequest(body);
      if (response.success === true) {
        setShowWithdraw(true);
      } else if (response.success === false) {
        setShowError(true);
      }
    } catch (error) {
      console.error("Error withdrawing request:", error);
      setShowError(true);
    } finally {
      setWithdrawLoading(false);
    }
  };

  /*** 
  @purpose : Change route
  @Parameter : {e, page}
  **/
  const changeRoute = (e, page) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    navigate(page);
  };

  /*** 
@purpose : Unix time stamp to YYYY-MM-DD
@Parameter : {timestamp}
**/
  const unixToYYYYMMDD = (timestamp) => {
    var a = new Date(timestamp * 1000);
    var year = a.getFullYear();
    let month = a.getMonth() + 1;
    if (month.toString().length === 1) {
      month = '0' + month
    }
    var date = a.getDate();
    var time = year + '/' + month + '/' + date;
    return time;
  };

  return (
    <Home>
      <Breadcrumb routes={showWithdraw ? withdrawRoutes : routes} />
      {!requestNotFound && showWithdraw && !withdrawLoading && (
        <div className="card shadow-card">
          <div className="card-header">
            <h4>{lang("organizationDetails.completedLabel")}</h4>
          </div>
          <div className="card-body">
            <p className="mb-2 mt-2">
              {lang("errorMessages.YOUR_REQUEST")} {data.submission_id.value}{" "}
              {lang("errorMessages.CANCELLED")}
            </p>
          </div>
        </div>
      )}
      {withdrawLoading && <Spinner animation="border" />}
      {!isLoading && !showWithdraw && !withdrawLoading && (
        <>
          <h2>{lang("customerRequestStatus.orgRequestStatus")}</h2>
          <div className="card shadow-card">
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <div className="horizon-form2 form-group">
                    <div className="custom-3">
                      <label>
                        {lang("customerRequestStatus.submissionType")}
                      </label>
                    </div>
                    <div className="custom-9">
                      <input
                        type="text"
                        className="form-control"
                        value={data?.submission_type?.value ?? ""}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="horizon-form2 form-group">
                    <div className="custom-3">
                      <label>
                        {lang("customerRequestStatus.submissionData")}
                      </label>
                    </div>
                    <div className="custom-9">
                      <input
                        type="text"
                        className="form-control"
                        value={data?.submission_data?.value ?? ""}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="horizon-form2 form-group">
                    <div className="custom-3">
                      <label>
                        {lang("organizationDetails.unifiedCustomerCode")}
                      </label>
                    </div>
                    <div className="custom-9">
                      <input
                        type="text"
                        className="form-control"
                        value={
                          /* data && data.lagacy_unified_customer_code   /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                          /*   ? data.lagacy_unified_customer_code.value /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                          data?.unified_customer_code?.value ?? ""             /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                        }
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="horizon-form2 form-group">
                    <div className="custom-3">
                      <label>
                        {lang("customerRequestStatus.submissionStatus")}
                      </label>
                    </div>
                    <div className="custom-9">
                      <input
                        type="text"
                        className="form-control"
                        value={data?.submission_status?.value ?? ""}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="horizon-form2 form-group">
                    <div className="custom-3">
                      <label>{lang("organizationDetails.submissionID")}</label>
                    </div>
                    <div className="custom-9">
                      <input
                        type="text"
                        className="form-control"
                        value={data?.submission_id?.value ?? ""}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="horizon-form2 form-group">
                    <div className="custom-3">
                      <label>{lang("organizationDetails.requesterName")}</label>
                    </div>
                    <div className="custom-9">
                      <input
                        type="text"
                        className="form-control"
                        value={data?.requester_name?.value ?? ""}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="horizon-form2 form-group">
                    <div className="custom-3">
                      <label>{lang("organizationDetails.submittedDate")}</label>
                    </div>
                    <div className="custom-9">
                      <input
                        type="text"
                        className="form-control"
                        value={data?.submitted_date?.value ? unixToYYYYMMDD(data.submitted_date.value) : ""}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="horizon-form2 form-group">
                    <div className="custom-3">
                      <label>{lang("organizationDetails.modifiedDate")}</label>
                    </div>
                    <div className="custom-9">
                      <input
                        type="text"
                        className="form-control"
                        value={data?.modified_date?.value ? unixToYYYYMMDD(data.modified_date.value) : ""}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="horizon-form2 form-group">
                    <div className="custom-3">
                      <label>{lang("territoryDefinitionMaintenance.wwid")}</label>
                    </div>
                    <div className="custom-9">
                      <input
                        type="text"
                        className="form-control"
                        value={
                          data && data.submitted_by
                            ? data.submitted_by
                            : ""
                        }
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                {data.ultmarc_reception_code &&
                  data.ultmarc_reception_code.response_from_ultmarc && (
                    <div className="col-md-6">
                      <div className="horizon-form2 form-group">
                        <div className="custom-3">
                          <label>
                            {lang(
                              "organizationDetails.reapplicationAcceptanceCode"
                            )}
                          </label>
                        </div>
                        <div className="custom-9">
                          <input
                            type="text"
                            className="form-control"
                            value={
                              data && data.ultmarc_reception_code
                                ? data.ultmarc_reception_code
                                  .response_from_ultmarc
                                : ""
                            }
                            readOnly
                          />
                        </div>
                      </div>
                    </div>
                  )}
              </div>
              <div className="buttons-group">
                {data &&
                  data.submission_type &&
                  data.submission_type.value === "New" && (
                    <>
                      <button
                        onClick={(e) => {
                          changeRoute(
                            e,
                            `/organizationRequestResubmit?orgId=${data && data.submission_id
                              ? data.submission_id.value
                              : ""
                            }`
                          );
                        }}
                        className="btn btn-primary"
                        disabled={!resubmit}
                      >
                        {lang("Buttons.resubmit")}
                      </button>
                      <button
                        onClick={(e) => {
                          changeRoute(
                            e,
                            `/organizationRequestEdit?orgId=${data && data.submission_id
                              ? data.submission_id.value
                              : ""
                            }`
                          );
                        }}
                        className="btn btn-primary"
                        disabled={!edit}
                      >
                        {lang("Buttons.edit")}
                      </button>
                    </>
                  )}
                {data &&
                  data.submission_type &&
                  data.submission_type.value === "Change" && (
                    <>
                      <button
                        onClick={(e) => {
                          changeRoute(
                            e,
                            `/organizationRequestResubmit?orgId=${data && data.submission_id
                              ? data.submission_id.value
                              : ""
                            }`
                          );
                        }}
                        className="btn btn-primary"
                        disabled={!resubmit}
                      >
                        {lang("Buttons.resubmit")}
                      </button>
                      <button
                        onClick={(e) => {
                          changeRoute(
                            e,
                            `/organizationRequestEdit?orgId=${data && data.submission_id
                              ? data.submission_id.value
                              : ""
                            }`
                          );
                        }}
                        className="btn btn-primary"
                        disabled={!edit}
                      >
                        {lang("Buttons.edit")}
                      </button>
                    </>
                  )}
                {data &&
                  data.submission_type &&
                  data.submission_type.value === "Delete" && (
                    <>
                      <button
                        onClick={(e) => {
                          changeRoute(
                            e,
                            `/organizationClosureRequestResubmit?orgId=${data && data.submission_id
                              ? data.submission_id.value
                              : ""
                            }`
                          );
                        }}
                        className="btn btn-primary"
                        disabled={!resubmit}
                      >
                        {lang("Buttons.resubmit")}
                      </button>
                      <button
                        onClick={(e) => {
                          changeRoute(
                            e,
                            `/organizationClosureRequestEdit?orgId=${data && data.submission_id
                              ? data.submission_id.value
                              : ""
                            }`
                          );
                        }}
                        className="btn btn-primary"
                        disabled={!edit}
                      >
                        {lang("Buttons.edit")}
                      </button>
                    </>
                  )}
                <button
                  className="btn btn-primary"
                  onClick={modalShow}
                  disabled={!withdraw}
                >
                  {lang("Buttons.withdraw")}
                </button>
              </div>
            </div>
          </div>
          <Modal
            size="sm"
            className="withdraw-modal"
            show={show}
            onHide={handleClose}
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Body>
              <div className="warning-msg">
                <img src="images/warning2.svg" alt="Warning" />
                {lang("errorMessages.CANCEL_REQUEST")}
              </div>
              <div className="buttons-group">
                <button className="btn btn-primary" onClick={withdrawRequest}>
                  {lang("Buttons.ok")}
                </button>
                <button className="btn btn-primary" onClick={handleClose}>
                  {lang("Buttons.cancel")}
                </button>
              </div>
            </Modal.Body>
          </Modal>
          <div className="table-responsive simple-table">
            <table className="table" aria-describedby="table">
              <thead>
                <tr>
                  <th scope="col">{lang("customerRequestStatus.item")}</th>
                  <th scope="col">
                    {lang("customerRequestStatus.submittedValue")}
                  </th>
                  <th scope="col">
                    {lang("customerRequestStatus.responseFromUltmarc")}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{lang("organizationDetails.customerType")}</td>
                  <td>
                    {data && data.customer_type ? data.customer_type.value_local ? data.customer_type.value_local : data.customer_type.value : ""}
                  </td>
                  <td>
                    {data && data.customer_type
                      ? data.customer_type.response_from_ultmarc
                      : ""}
                  </td>
                </tr>
                <tr>
                  <td>{lang("OrganizationMenu.kanjiFacilityName")}</td>
                  <td>
                    {data && data.facility_name_kanji
                      ? data.facility_name_kanji.value
                      : ""}
                  </td>
                  <td>
                    {data && data.facility_name_kanji
                      ? data.facility_name_kanji.response_from_ultmarc
                      : ""}
                  </td>
                </tr>
                <tr>
                  <td>{lang("OrganizationMenu.kanaFacilityName")}</td>
                  <td>
                    {data && data.facility_name_kana
                      ? data.facility_name_kana.value
                      : ""}
                  </td>
                  <td>
                    {data && data.facility_name_kana
                      ? data.facility_name_kana.response_from_ultmarc
                      : ""}
                  </td>
                </tr>
                <tr>
                  <td>{lang("organizationDetails.managementBody")}</td>
                  <td>
                    {data && data.management_body
                      ? data.management_body.value
                      : ""}
                  </td>
                  <td>
                    {data && data.management_body
                      ? data.management_body.response_from_ultmarc
                      : ""}
                  </td>
                </tr>
                <tr>
                  <td>{lang("organizationDetails.postalCode")}</td>
                  <td>
                    {data && data.postal_code ? data.postal_code.value : ""}
                  </td>
                  <td>
                    {data && data.postal_code
                      ? data.postal_code.response_from_ultmarc
                      : ""}
                  </td>
                </tr>
                <tr>
                  <td>{lang("parentChildFacilityMaintenance.prefecture")}</td>
                  <td>
                    {data && data.prefecture ? data.prefecture.value : ""}
                  </td>
                  <td>
                    {data && data.prefecture
                      ? data.prefecture.response_from_ultmarc
                      : ""}
                  </td>
                </tr>
                <tr>
                  <td>{lang("parentChildFacilityMaintenance.city")}</td>
                  <td>{data && data.city ? data.city.value : ""}</td>
                  <td>
                    {data && data.city ? data.city.response_from_ultmarc : ""}
                  </td>
                </tr>
                <tr>
                  <td>{lang("organizationDetails.suburb")}</td>
                  <td>{data && data.suburb ? data.suburb.value : ""}</td>
                  <td>
                    {data && data.suburb
                      ? data.suburb.response_from_ultmarc
                      : ""}
                  </td>
                </tr>
                <tr>
                  <td>{lang("organizationDetails.street")}</td>
                  <td>{data && data.suburb ? data.street.value : ""}</td>
                  <td>
                    {data && data.street
                      ? data.suburb.response_from_ultmarc
                      : ""}
                  </td>
                </tr>
                <tr>
                  <td>{lang("organizationDetails.kanjiAddressLine")}</td>
                  <td>
                    {data && data.address_line_kanji
                      ? data.address_line_kanji.value
                      : ""}
                  </td>
                  <td>
                    {data && data.address_line_kanji
                      ? data.address_line_kanji.response_from_ultmarc
                      : ""}
                  </td>
                </tr>
                <tr>
                  <td>{lang("organizationDetails.kanaAddressLine")}</td>
                  <td>
                    {data && data.address_line_kana
                      ? data.address_line_kana.value
                      : ""}
                  </td>
                  <td>
                    {data && data.address_line_kana
                      ? data.address_line_kana.response_from_ultmarc
                      : ""}
                  </td>
                </tr>
                <tr>
                  <td>{lang("OrganizationMenu.tel")}</td>
                  <td>{data && data.tel ? data.tel.value : ""}</td>
                  <td>
                    {data && data.tel ? data.tel.response_from_ultmarc : ""}
                  </td>
                </tr>
                <tr>
                  <td>
                    {lang("organizationDetails.representativePersonCode")}
                  </td>
                  <td>
                    {data && data.representative_person_code
                      ? data.representative_person_code.value
                      : ""}
                  </td>
                  <td>
                    {data && data.representative_person_code
                      ? data.representative_person_code.response_from_ultmarc
                      : ""}
                  </td>
                </tr>
                <tr>
                  <td>
                    {lang("organizationDetails.kanjiRepresentativePerson")}
                  </td>
                  <td>
                    {data && data.representative_person_name_kanji
                      ? data.representative_person_name_kanji.value
                      : ""}
                  </td>
                  <td>
                    {data && data.representative_person_name_kanji
                      ? data.representative_person_name_kanji
                        .response_from_ultmarc
                      : ""}
                  </td>
                </tr>
                <tr>
                  <td>
                    {lang("organizationDetails.kanaRepresentativePerson")}
                  </td>
                  <td>
                    {data && data.representative_person_name_kana
                      ? data.representative_person_name_kana.value
                      : ""}
                  </td>
                  <td>
                    {data && data.representative_person_name_kana
                      ? data.representative_person_name_kana
                        .response_from_ultmarc
                      : ""}
                  </td>
                </tr>
                <tr>
                  <td>{lang("OrganizationMenu.kanjiPharmacist")}</td>
                  <td>
                    {data && data.supervising_person_name_kanji
                      ? data.supervising_person_name_kanji.value
                      : ""}
                  </td>
                  <td>
                    {data && data.supervising_person_name_kanji
                      ? data.supervising_person_name_kanji.response_from_ultmarc
                      : ""}
                  </td>
                </tr>
                <tr>
                  <td>{lang("OrganizationMenu.kanaPharmacist")}</td>
                  <td>
                    {data && data.supervising_person_name_kana
                      ? data.supervising_person_name_kana.value
                      : ""}
                  </td>
                  <td>
                    {data && data.supervising_person_name_kana
                      ? data.supervising_person_name_kana.response_from_ultmarc
                      : ""}
                  </td>
                </tr>
                <tr>
                  <td>{lang("organizationDetails.numberOfBeds")}</td>
                  <td>
                    {data && data.number_of_beds
                      ? data.number_of_beds.value
                      : ""}
                  </td>
                  <td>
                    {data && data.number_of_beds
                      ? data.number_of_beds.response_from_ultmarc
                      : ""}
                  </td>
                </tr>
                <tr>
                  <td>{lang("organizationDetails.plannedOpenDate")}</td>
                  <td>
                    {data && data.planned_open_date
                      ? data.planned_open_date.value
                      : ""}
                  </td>
                  <td>
                    {data && data.planned_open_date
                      ? data.planned_open_date.response_from_ultmarc
                      : ""}
                  </td>
                </tr>
                <tr>
                  <td>{lang("organizationDetails.specialities")}</td>
                  <td>{specialityList.join(",")}</td>
                  <td>{specialityResponseList.join(",")}</td>
                </tr>
                {data.submission_type &&
                  data.submission_type.value === "Delete" && (
                    <tr>
                      <td>{lang("organizationDetails.plannedDeleteReason")}</td>
                      <td>
                        {data && data.planned_delete_reason
                          ? data.planned_delete_reason.value
                          : ""}
                      </td>
                      <td>
                        {data && data.planned_delete_reason
                          ? data.planned_delete_reason.response_from_ultmarc
                          : ""}
                      </td>
                    </tr>
                  )}
                <tr>
                  <td>{lang("organizationDetails.remarks")}</td>
                  <td>{data && data.remarks ? data.remarks.value : ""}</td>
                  <td>
                    {data && data.remarks
                      ? data.remarks.response_from_ultmarc
                      : ""}
                  </td>
                </tr>
                {data &&
                  data.ultmarc_reception_code &&
                  (data.ultmarc_reception_code.value ||
                    data.ultmarc_reception_code.response_from_ultmarc) && (
                    <tr>
                      <td>
                        {lang(
                          "organizationDetails.reapplicationAcceptanceCode"
                        )}
                      </td>
                      <td>
                        {data && data.ultmarc_reception_code
                          ? data.ultmarc_reception_code.value
                          : ""}
                      </td>
                      <td>
                        {data && data.ultmarc_reception_code
                          ? data.ultmarc_reception_code.response_from_ultmarc
                          : ""}
                      </td>
                    </tr>
                  )}
              </tbody>
            </table>
          </div>
        </>
      )}
      {isLoading && <Spinner animation="border" />}
      <Modal
        size="md"
        className="withdraw-modal"
        show={requestNotFound}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <div className="warning-msg">
            <img src="images/warning2.svg" alt="Warning" />
            {lang("errorMessages.NOT_FOUND")}
          </div>
          <p className="mb-3">
            {lang("errorMessages.SEARCH_REQUESTS")}
            <a
              className="link"
              onClick={(e) => {
                changeRoute(e, "/customerRequestStatus");
              }}
            >
              {lang("Menu.customerRequestStatus")}
            </a>
          </p>
        </Modal.Body>
      </Modal>
      <Modal
        size="sm"
        className="withdraw-modal"
        show={showError}
        onHide={handleCloseError}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <div className="warning-msg">
            <img src="images/warning2.svg" alt="Warning" />
            {lang("errorMessages.REQUEST_NOT_SUBMITTED")}
          </div>
          <div className="buttons-group">
            <button className="btn btn-primary" onClick={handleCloseError}>
              {lang("Buttons.ok")}
            </button>
            <button className="btn btn-primary" onClick={handleCloseError}>
              {lang("Buttons.cancel")}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </Home>
  );
}

export default OrganizationCustomerDetails;
